import { Body, Box, Button } from '@hover/blueprint';
import { captureException } from '@sentry/react';
import React from 'react';
import { Trans } from 'react-i18next';

import {
  useProfileQuery,
  useStopImpersonationMutation,
} from 'src/shared/graphql/generated';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

export const ImpersonatorBanner = () => {
  const { data, loading, error } = useProfileQuery();
  const [stopImpersonation] = useStopImpersonationMutation();
  const t = useTranslate(TranslationNamespace.PROPERTY_DETAILS);

  const currentImpersonator = data?.profile?.impersonator;
  const currentUser = data?.profile?.user;

  if (!currentImpersonator || !currentUser || loading || error) return null;

  const handleStopImpersonation = async () => {
    try {
      await stopImpersonation();

      window.location.reload();
    } catch (err) {
      captureException(err);
    }
  };

  return (
    <Box
      alignItems="center"
      backgroundColor="warning.100"
      height={400}
      justifyContent="center"
      role="alert"
    >
      <Body mx={300} size={300}>
        <Trans i18nKey="impersonationBanner" t={t}>
          You <strong>{{ currentImpersonator }}</strong>, are currently
          impersonating the user <strong>{{ currentUser }}</strong>.
        </Trans>
      </Body>
      <Button
        backgroundColor="neutral.0"
        color="primary"
        fill="outline"
        onClick={handleStopImpersonation}
        size="small"
      >
        {t('endImpersonationButton')}
      </Button>
    </Box>
  );
};
